/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScreeningListType {
    SANCTION = 'SANCTION',
    PEP = 'PEP',
    ADVERSE_MEDIA = 'ADVERSE_MEDIA',
    ADVERSE_MEDIA_ENTITY = 'ADVERSE_MEDIA_ENTITY',
    CUSTOM_LIST = 'CUSTOM_LIST'
}


export function instanceOfInternalApiScreeningListType(value: any): boolean {
    for (const key in InternalApiScreeningListType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScreeningListType, key)) {
            if (InternalApiScreeningListType[key as keyof typeof InternalApiScreeningListType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScreeningListTypeFromJSON(json: any): InternalApiScreeningListType {
    return InternalApiScreeningListTypeFromJSONTyped(json, false);
}

export function InternalApiScreeningListTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScreeningListType {
    return json as InternalApiScreeningListType;
}

export function InternalApiScreeningListTypeToJSON(value?: InternalApiScreeningListType | null): any {
    return value as any;
}

export function InternalApiScreeningListTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScreeningListType {
    return value as InternalApiScreeningListType;
}

